import { useCallback, useMemo, useState } from 'react';
import { getJsonItem, setJsonItem } from 'util/localStorage';

const STORAGE_KEY_BASE = 'UTILIHIVE:';

const useLocalStorageState = (name, defaultValue) => {
  const key = useMemo(() => STORAGE_KEY_BASE + name, [name]);
  const [value, setValueState] = useState(getJsonItem(key) === null ? defaultValue : getJsonItem(key));
  const setValue = useCallback(
    valueOrCallback => {
      if (typeof valueOrCallback === 'function') {
        const newValue = valueOrCallback(value);
        setJsonItem(key, newValue);
        setValueState(newValue);
      } else {
        setJsonItem(key, valueOrCallback);
        setValueState(valueOrCallback);
      }
    },
    [value, key]
  );
  return [value, setValue];
};

export default useLocalStorageState;
